<template>
  <div class="regist">
    <div class="u-containar-md">
      <HeadingLv2 text="イベント申込み / 会員登録" simple />
      <FlowRegisterEvents :current="5" />

      <div class="registThanks">
        <p class="registThanks_heading">申込み/登録が完了しました</p>

        <div
          class="registThanks_attention"
          v-if="
            $route.query.invitationCode === 'OK' ||
              $route.query.invitationCode === 'NG'
          "
        >
          <div v-if="$route.query.invitationCode === 'OK'">
            <p>
              キャンペーンのご申請を受け付けました。<br />
              ヒポクラ×マイナビからメールが送信されていますので、引き続きお忘れなきよう、本登録のお手続きをお願いします。<br />
              <span class="small">
                ※キャンペーン特典の受け取りには、ヒポクラ×マイナビの本登録を行っていただく必要があります。
              </span>
            </p>
          </div>
          <div v-if="$route.query.invitationCode === 'NG'">
            <p>
              キャンペーンのご申請に失敗しました。<br />
              大変お手数ではございますが、下記事務局までご連絡をお願いいたします。
            </p>
            <p>
              ◆お問い合わせ<br />
              マイナビRESIDENT運営事務局
              <TextLink
                link="/contact/input"
                :text="`${appUrl}/contact/input`"
              />
            </p>
          </div>
        </div>

        <p>
          申込み/登録した情報は、マイページから確認できます。キャンセルをしたい場合は、マイページの「申込イベント一覧」ページからキャンセルのお手続きを行ってください。
        </p>
      </div>
    </div>

    <GoalButtons type="contents">
      <Button
        label="イベントページへ戻る"
        :handleClick="
          () => $router.push(`/events/detail/${$route.query.event_id}`)
        "
      />
      <Button
        label="トップページへ"
        primary
        :handleClick="() => $router.push('/')"
      />
    </GoalButtons>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import FlowRegisterEvents from '@/components/block/FlowRegisterEvents.vue'
import GoalButtons from '@/components/block/GoalButtons.vue'
import Button from '@/components/elements/Button.vue'
import TextLink from '@/components/elements/TextLink.vue'

export default defineComponent({
  name: 'RegisterEventsThanks',

  components: {
    HeadingLv2,
    FlowRegisterEvents,
    GoalButtons,
    Button,
    TextLink
  },

  setup() {
    const appUrl = process.env.VUE_APP_URL

    onMounted(() => {
      localStorage.removeItem('userSelection')
      localStorage.removeItem('registerEvent')
    })

    return { appUrl }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;
.regist {
  padding-bottom: 40px;
}

.registThanks {
  margin-top: 57px;
}

.registThanks_heading {
  font-size: 2.2rem;
  text-align: center;
  color: var.$color-main-text;
  font-weight: 500;

  & + p {
    margin-top: 14px;
  }
}

.registThanks_attention {
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 16px 20px;
  border: 1px solid #f64545;

  p + p {
    margin-top: 16px;
  }

  .small {
    font-size: 1.2rem;
  }
}

.section {
  margin-top: 48px;
  margin-bottom: 48px;
}

.searchHospitalSec {
  .headingLv2 {
    margin-bottom: 17px;
  }
  .button {
    margin-top: 30px;
  }
}
</style>
